
import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellButtonResult(select) {
    return class extends GridCell {
        render() {
            return (
                <td>
                    <button class="k-button k-flat k-button-icontext" onClick={() => { select(this.props.dataItem); }}>
                        <i class="fas fa-file" style={{"margin-right": "5px"}}></i>Upload</button>                                                
                </td>
            );
        }
    };
} 